import { baseNormalizeData } from './baseNormalizeData';

export const normalizeContentCreatedData = (data: any) => {
	const { metadata } = baseNormalizeData(data);

	return {
		date: metadata.createdDate,
	};
};
